<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="ded"> </p>
<p class="ded">This book is dedicated to the residents of Union, South Carolina, who came together in tragedy and, by their unbending love and faith, showed the nation the true meaning of community. In their hearts, Michael and Alex Smith will live on always.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?4c49be70